import React from 'react';
import { useTranslation } from 'react-i18next';
import { getTagByStatus } from '../IntegrationCardsUtils';
import { IntegrationType } from '../../../../types/integrationTypes';
import { convertIntegrationTypeToDescription, convertIntegrationTypeToStringService } from '../../../../utils/IntegrationUtils';
import { images } from '../../../../constants/images';
import styles from '../IntegrationCard/IntegrationCard.module.scss';

interface StiggIntegrationCardProps extends IntegrationType {
	showOnlyIcon?: boolean;
	platformIsChosen?: boolean;
}

export const StiggIntegrationCard = ({
	platform,
	iconSrc,
	connectionStatus,
}: StiggIntegrationCardProps) => {
	const { t } = useTranslation('translation');

	return (
		<div className={styles.card}>
			<div className={styles.topContainer}>
				<div className={styles.iconContainer}>
					<img alt='cardIcon' src={images[iconSrc]} className={styles.cardIcon}></img>
				</div>
				{getTagByStatus(t, connectionStatus)}
			</div>

			<h2>{t(convertIntegrationTypeToStringService(platform))}</h2>

			<span className={styles.cardDescription}>{t(convertIntegrationTypeToDescription(platform))}</span>
		</div>
	);
};
